/* global cylinder_pos, reels_lenghts, stopposin, stopposin_old, server_config */

import {config_set_cfg, cylinder_pos, set_game_config} from "./jokerboom_config";
import {
    madnes_add_child,
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite, madnes_add_to_group,
    madnes_set_alpha, madnes_set_angle, madnes_set_img_center, madnes_set_pos, madnes_set_scale,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    server_config,
    he,
    reels_lenghts,
    reels_pos,
    wi,
    picture_convert
} from "../framework/src/engine/madnes/madnes_variables";
import {jboom_last_server_result, stopposin, stopposin_old} from "./jokerboom_core";
import {
    madnes_add_graphics,
    madnes_graphics_begin_fill,
    madnes_graphics_draw_rectangle
} from "../framework/src/engine/madnes/madnes_draw";
import {madnes_anim_add, madnes_generate_frame_names} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_add_bitmap_text, madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {madnes_audio_allow_multiple} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_alpha_to} from "../framework/src/engine/madnes/madnes_render";
import {
    ctrl_get_reel_symbol_name,
    ctrl_init_bonus,
    ctrl_set_bigwin_type,
    ctrl_set_win_text_bg,
    set_locked_wild
} from "./jokerboom_ctrl";
import {hide_all_bw_particles, hide_black_screen} from "./jokerboom_anims";
import {draw_winlines, hide_all_winlines} from "./jokerboom_winlines";
import {coins_create} from "./jokerboom_coins";
import { madnes_get_game_specifics } from "../framework/src/engine/madnes/madnes";
import AddResult from "../framework/src/connect/result/AddResult";

function hide_all_symbols()
{
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        madnes_set_visible("reels_bufer_"+i+"_S0", false);
        madnes_set_visible("reels_bufer_"+i+"_S1", false);
        madnes_set_visible("reels_bufer_"+i+"_S2", false);
    }
}

export var bigwin_particle_positions = {};
export var boomspins_particle_positions = {};
export var bw_particles_tmp = {};

// Vytvoreni potrebnych onjektu z nactenych textur.
export function reels_print_desk()
{
    config_set_cfg();
    set_game_config();

    madnes_add_img("preload_bigwins", "bigwins", -9999, -9999);
    madnes_set_visible("preload_bigwins", false);

    madnes_add_sprite("background", "background", 0, 0);

    madnes_add_sprite("background2", "background_bonus", -9999, -9992);
    madnes_set_visible("background2", false);
    madnes_set_alpha("background2", 0);

    /*var colorMatrix = new PIXI.filters.ColorMatrixFilter();

    madnes_objects["background"].filters = [colorMatrix];*/

    /*bmd = main_phaser.make.bitmapData(wi, he);
    bmd.copy('background');
    bmd.setHSL(0.5, 0.5, 0.5);
    bmd.addToWorld();*/

    //madnes_objects["background"].blendMode = 0xffffff;

    var symbolName = "symbol_Seven";
    var textureName = symbolName + "_sprite_json";

    //console.log(server_config.matrix.reelMatrix);

    madnes_add_img("wild_bg", "wild_bg", -9999, -9999, 1, 0.5, 0.5);
    madnes_set_scale("wild_bg", 0.8, 0.8);

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        madnes_add_group("reel_group_" + i);

        for(var j in server_config.logic.reels[i])
        {
            symbolName = ctrl_get_reel_symbol_name(server_config.logic.reels, i, j);
            textureName = symbolName + "_sprite_json";

            madnes_add_img("reels_bufer_"+i+"_"+j, textureName, cylinder_pos[i], -9999, 1, 0.5, 0.5, symbolName /*+ "_blur"*/);
            //madnes_sprite_set_frame("reels_bufer_"+i+"_"+j, 1);

            reels_lenghts[i] = j * 1 + 1;
            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];
        }

        // S0-S2 = priprava vyherni pozice na kazdem valci

        for(var j = 0; j <= 2; j++) {
            symbolName = ctrl_get_reel_symbol_name(server_config.matrix.reelMatrix, i, 2 - j);
            textureName = symbolName + "_sprite_json";

            madnes_add_sprite("reels_bufer_" + i + "_S" + j, textureName, cylinder_pos[i], -9999, 1, 0.5, 0.5, symbolName);
        }

        /*madnes_add_sprite("reels_bufer_"+i+"_S0", "symbols_json", cylinder_pos[i], -9999, 1, 0.5, 0.5, );
        madnes_add_sprite("reels_bufer_"+i+"_S1", "symbols_json", cylinder_pos[i], -9999, 1, 0.5, 0.5, ctrl_get_reel_symbol_name(server_config.matrix.reelMatrix[0], i, 1));
        madnes_add_sprite("reels_bufer_"+i+"_S2", "symbols_json", cylinder_pos[i], -9999, 1, 0.5, 0.5, ctrl_get_reel_symbol_name(server_config.matrix.reelMatrix[0], i, 0));*/

        reels_pos[i] = 0;
    }

    madnes_add_graphics("black_screen_graphics", 0, 0);
    madnes_graphics_begin_fill("black_screen_graphics", 0x000000);
    madnes_graphics_draw_rectangle("black_screen_graphics", 45, 36, wi - 45 * 2, he - 36 * 2);
    madnes_set_alpha("black_screen_graphics", 0.65);
    hide_black_screen();

    draw_winlines();
    hide_all_winlines();

    madnes_add_img("wild_reel_bg", "big_wild_bg", 190, 340, 1, 0.5, 0.5);

    madnes_add_sprite("preload_coin", "coins_json", wi, he, 1, 0.5, 0.5);
    madnes_set_visible("preload_coin", false);

    madnes_add_img("cover", "cover", 0, 0);

    //madnes_add_img("win_frame", "win_frame", 0, 0);
    //madnes_set_visible("win_frame", false);

    madnes_add_group("group_winframe");

    madnes_add_img("win_frame_left", "win_frame_left", 0, 0);
    madnes_add_to_group("group_winframe", "win_frame_left");

    madnes_add_img("win_frame_top", "win_frame_top", 100, 0);
    madnes_add_to_group("group_winframe", "win_frame_top");

    madnes_add_img("win_frame_right", "win_frame_right", wi, 0);
    madnes_set_img_center("win_frame_right", 1, 0);
    madnes_add_to_group("group_winframe", "win_frame_right");

    madnes_add_img("win_frame_bottom", "win_frame_bottom", 100, he);
    madnes_set_img_center("win_frame_bottom", 0, 1);
    madnes_add_to_group("group_winframe", "win_frame_bottom");

    madnes_set_visible("group_winframe", false);


    madnes_add_img("win_particle_preload", "particles_json", -9999, -9999);
    madnes_set_visible("win_particle_preload", false);

    //madnes_add_img("bigwin_particle_preload", "particles_bigwin_json", -9999, -9999);
    //madnes_set_visible("bigwin_particle_preload", false);

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        for(var j = 0; j <= 2; j++)
        {
            (function(i, j) {

                madnes_add_sprite("reels_bufer_" + i + "_TMP" + j, "symbol_Seven_sprite_json", cylinder_pos[i], -9999, 1, 0.5, 0.5, picture_convert[0]);

                /*madnes_add_sprite("reels_bufer_" + i + "_WILD" + j, "wild_locked_json", cylinder_pos[i], -9999, 1, 0.5, 0.5, "symbol_Wild_locked_00000");
                madnes_anim_add("reels_bufer_" + i + "_WILD" + j, "anim", icons["symbol_Wild_locked"]["anim"]);
                madnes_anim_add_oncomplete("reels_bufer_" + i + "_WILD" + j, function() {

                    var x = madnes_get_pos_x("reels_bufer_" + i + "_WILD" + j);
                    madnes_set_pos_x("reels_bufer_" + i + "_WILD" + j, -9999);
                    madnes_set_pos_x("reels_bufer_" + i + "_S" + j, x);

                });*/
            } (i, j));
        }
    }

    madnes_add_sprite("reels_bufer_" + 0 + "_WILD0", "symbol_Wild_sprite_json", cylinder_pos[0], -9999, 1, 0.5, 0.5, "symbol_Wild");
    madnes_add_sprite("reels_bufer_" + 0 + "_WILD1", "symbol_Wild_sprite_json", cylinder_pos[0], -9999, 1, 0.5, 0.5, "symbol_Wild");
    madnes_add_sprite("reels_bufer_" + 0 + "_WILD2", "symbol_Wild_sprite_json", cylinder_pos[0], -9999, 1, 0.5, 0.5, "symbol_Wild");


    madnes_add_img("wild_reel", "big_wild", 190, 340, 1, 0.5, 0.5);
    madnes_set_scale("wild_reel", 0.8, 0.8);
    madnes_set_visible("wild_reel", true);

    madnes_add_sprite("bubbles", "", wi / 2, he / 2, 1, 0.5, 0.5); //blank parent (bubble container)

    madnes_add_img("bubble1", "bigwins", 30, - 80, 1, 0.5, 0.5, "bubbles");
    madnes_set_angle("bubble1", -40);
    madnes_add_child("bubbles", "bubble1");

    madnes_add_img("bubble2", "bigwins", -100, -40, 1, 0.5, 0.5, "bubbles"); // wi / 2 - 100, he / 2 - 40
    madnes_set_angle("bubble2", 120);
    madnes_add_child("bubbles", "bubble2");
    //madnes_add_to_group("group_bubbles", "bubble2");

    madnes_add_img("bubble3", "bigwins", 40, 40, 1, 0.5, 0.5, "bubbles");
    madnes_set_angle("bubble3", -60);
    madnes_add_child("bubbles", "bubble3");
    //madnes_add_to_group("group_bubbles", "bubble3");

    madnes_add_img("bubble4", "bigwins", 100, 20 , 1, 0.5, 0.5, "bubbles");
    madnes_set_angle("bubble4", 20);
    madnes_add_child("bubbles", "bubble4");
    //madnes_add_to_group("group_bubbles", "bubble4");*/

    var particleFrames = madnes_generate_frame_names("particles_", 0, 34, "", 5);

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        for(var j = 0; j <= 2; j++)
        {
            madnes_add_sprite("reels_bufer_" + i + "_PARTICLES" + j, "particles_json", cylinder_pos[i], -9999, 1, 0.5, 0.5);
            madnes_set_scale("reels_bufer_" + i + "_PARTICLES" + j, 2, 2);
            madnes_set_visible("reels_bufer_" + i + "_PARTICLES" + j, false);

            madnes_anim_add("reels_bufer_" + i + "_PARTICLES" + j, "anim", particleFrames);
        }
    }

    var bwPartsScale = 2;
    var bsPartsScale = 2;

    boomspins_particle_positions = {
        0: { x: wi / 2 - 140, y: he / 2 - 100, scale: bsPartsScale },
        1: { x: wi / 2 + 120, y: he / 2 - 80, scale: bsPartsScale },
        2: { x: wi / 2 - 160, y: he / 2 + 80, scale: bsPartsScale },
        3: { x: wi / 2 + 140, y: he / 2 + 100, scale: bsPartsScale },
        4: { x: wi / 2, y: he / 2, scale: bsPartsScale },
    };

    bigwin_particle_positions = {
        0: { x: wi / 2 - 180, y: he / 2 - 120, scale: bwPartsScale },
        1: { x: wi / 2 + 200, y: he / 2 - 100, scale: bwPartsScale },
        2: { x: wi / 2 - 200, y: he / 2 + 120, scale: bwPartsScale },
        3: { x: wi / 2 + 160, y: he / 2 + 120, scale: bwPartsScale },
        4: { x: wi / 2 - 20, y: he / 2 + 140, scale: bwPartsScale },
        5: { x: wi / 2 + 30, y: he / 2 - 120, scale: bwPartsScale },
        6: { x: wi / 2 - 210, y: he / 2 + 20, scale: bwPartsScale },
        7: { x: wi / 2 + 240, y: he / 2 + 20, scale: bwPartsScale },
        //8: { x: wi / 2 - 90, y: he / 2 - 100, scale: bwPartsScale },
        //9: { x: wi / 2 + 100, y: he / 2 + 130, scale: bwPartsScale },
    };

    bw_particles_tmp = bigwin_particle_positions;

    if(Object.keys(boomspins_particle_positions).length > Object.keys(bigwin_particle_positions).length) {
        bw_particles_tmp = boomspins_particle_positions;
    }

    var bwParticlesFrames = madnes_generate_frame_names("particles_", 0, 34 /*32*/, "", 5); //particles_bigWin_

    for(var i in bw_particles_tmp) {
        madnes_add_sprite("bw_particles_" + i, "particles_json", -9999, -9999, 1, 0.5, 0.5);
        madnes_anim_add("bw_particles_" + i, "anim", bwParticlesFrames);
        madnes_set_visible("bw_particles_" + i, false);
    }

    hide_all_bw_particles();
    //set_bigwin_particles_positions();

    coins_create();

    madnes_add_img("win_text_bg", "wingb", wi / 2, he / 2 - 15, 1, 0.5, 0.5, "null_7");

    madnes_add_bitmap_text("win_text_2", "font_bigwins_edited", wi / 2 - 1, he / 2 - 11, "", 72);
    madnes_set_img_center("win_text_2", 0.5, 0.5);

    madnes_add_bitmap_text("win_text", "font_bigwins_edited", wi / 2 - 4, he / 2 - 15, "", 72);
    madnes_set_img_center("win_text", 0.5, 0.5);

    //write_win_text("123456789");
    hide_win_text();

    /*madnes_add_bitmap_text("win_text", "font_bigwins", 0, 0, "0123456.ab", 80);
    madnes_set_img_center("win_text", 0, 0);
    madnes_add_child("win_text_bg", "win_text");*/


    madnes_add_group("group_boom_spins");
    madnes_add_img("bs_boom", "boom_spins_json", 0, 0, 1, 0.5, 0.5, "boom");
    madnes_add_img("bs_spins", "boom_spins_json", 0, 0 + 120, 1, 0.5, 0.5, "spins");
    madnes_add_img("bs_num", "boom_spins_json", 0, 0 - 120, 1, 0.5, 0.5, "10");
    madnes_add_to_group("group_boom_spins", "bs_boom");
    madnes_add_to_group("group_boom_spins", "bs_spins");
    madnes_add_to_group("group_boom_spins", "bs_num");
    madnes_set_pos("group_boom_spins", wi / 2, he / 2);
    madnes_set_visible("group_boom_spins", false);

    madnes_add_img("game_logo", "game_logo", wi / 2, 0, 1, 0.5, 0);

    madnes_add_img("81_right", "81_right", wi, he / 2 - 10, 1, 1, 0.5);
    madnes_add_img("81_left", "81_left", 0, he / 2 - 10, 1, 0, 0.5);

    madnes_add_img("clock", "clock", wi / 2, -10, 1, 0.5, 0);
    //madnes_set_visible("clock", false);

    madnes_add_bitmap_text("bonus_count", "font_freespins", 0, 80, "", 38);
    madnes_set_img_center("bonus_count", 0.5, 0.5);
    madnes_add_child("clock", "bonus_count");

    madnes_add_group("bigwins");

    madnes_add_img("bigwins_sparkle", "bigwins", wi / 2, he / 2, 1, 0.5, 0.5, "sparkle");
    madnes_add_img("bigwins_bwin", "bigwins", wi / 2, he / 2, 1, 0.5, 0.5, "bigwin_label");
    madnes_add_img("bigwins_mwin", "bigwins", wi / 2, he / 2, 1, 0.5, 0.5, "megawin_label");
    madnes_add_img("bigwins_swin", "bigwins", wi / 2, he / 2, 1, 0.5, 0.5, "supermegawin_label");

    madnes_add_bitmap_text("bigwin_text_2", "font_bigwins", wi / 2 + 23, he / 2 + 114, "", 80);
    madnes_set_img_center("bigwin_text_2", 0.5, 0.5);
    madnes_set_angle("bigwin_text_2", -10);

    madnes_add_bitmap_text("bigwin_text", "font_bigwins", wi / 2 + 20, he / 2 + 110, "", 80);
    madnes_set_img_center("bigwin_text", 0.5, 0.5);
    madnes_set_angle("bigwin_text", -10);

    madnes_add_to_group("bigwins", "bigwins_sparkle");
    madnes_add_to_group("bigwins", "bigwins_bwin");
    madnes_add_to_group("bigwins", "bigwins_mwin");
    madnes_add_to_group("bigwins", "bigwins_swin");
    madnes_add_to_group("bigwins", "bigwin_text_2");
    madnes_add_to_group("bigwins", "bigwin_text");

    ctrl_set_bigwin_type("");

    madnes_audio_allow_multiple("reel_stop");
    madnes_audio_allow_multiple("symbol_joker");
    madnes_audio_allow_multiple("symbol_star");

    //madnes_audio_loop("BACKGROUND");

    //ctrl_init_bonus();

    /*var filter = new PIXI.ColorMatrixFilter();

    madnes_objects["background"].filters = [filter];

    /*console.log(main_phaser.cache.getShader('colorize_hsl'));

    var width = 800;
    var height = 800;

    var uniforms = {};
    uniforms.CC_Texture0 = {
        type: 'sampler2D',
        value: madnes_objects["background"].texture
    };
    uniforms.Vec2_1 = {
        type: 'v2',
        value:{x: 1.0, y: 2.0 }
    };

    filter = new Phaser.Filter(main_phaser, uniforms, main_phaser.cache.getShader('colorize_hsl'));
    madnes_objects["background"].filters = [filter];*/

    //var filter = new Phaser.Filter(main_phaser, { "Vec3_1": { type: '3f', value: { x: 163, y: 30, z: 5 } } }, main_phaser.cache.getShader('hsv'));
    //madnes_objects["background"].filters = [filter];

    //set_hue_big_wildbg(true);
    /*
    var graphics = main_phaser.add.graphics(0, 0);
    graphics.lineStyle(1, 0x33FF00);
    graphics.moveTo(0, he / 2);
    graphics.lineTo(wi, he / 2);
    */

    ctrl_init_bonus();
    set_locked_wild(false);

//	madnes_recount_bet();
}

export function get_result_special_state()
{
    return get_result_specifics() ? get_result_specifics()['specialState'] : {};
}

export function get_init_special_state()
{
    return get_init_specifics()['specialState'];
}

export function get_result_specifics()
{
    if(jboom_last_server_result)
    {
        return jboom_last_server_result.result.is_bonus ? jboom_last_server_result.result['fsGameSpecifics']:jboom_last_server_result.result['gameSpecifics'];
    }

    return;
}

function get_init_specifics()
{
    return madnes_get_game_specifics()
}

export function set_cover_lightness(bool) {

    return new Promise(function(res) {

        if(bool) {

            madnes_set_visible("group_winframe", true);
            madnes_set_alpha("group_winframe", 0);
            madnes_alpha_to("group_winframe", 1, 120, res);

        } else {

            madnes_set_alpha("group_winframe", 1);
            madnes_alpha_to("group_winframe", 0, 120, function() {
                madnes_set_visible("group_winframe", false);
                res();
            });
        }

    });
}

//function set_hue_background(bool) {
//	/*if(bool) {
//		madnes_objects["background2"].filters = [get_background_filter()];
//	} else {
//		madnes_objects["background2"].filters = null;
//	}*/
//}

//function set_hue_big_wildbg(bool) {
//	/*if(bool) {
//		madnes_objects["wild_reel_bg"].filters = [new Phaser.Filter(main_phaser, { "Vec3_1": { type: '3f', value: { x: 163, y: 30, z: 0 } } }, main_phaser.cache.getShader('hsv'))];
//	} else {
//		madnes_objects["wild_reel_bg"].filters = null;
//	}*/
//}

// function get_cover_filter() {
// 	var light = new PIXI.ColorMatrixFilter();
// 	light.matrix = [
// 		1,0,0,0,
// 		0,1,0,0,
// 		0,0,1,0.12,
// 		0,0,0,1
// 	];
// 	return light;
// }

//function get_background_filter() {
//
//	return new Phaser.Filter(main_phaser, { "Vec3_1": { type: '3f', value: { x: 163, y: 30, z: 5 } } }, main_phaser.cache.getShader('hsv'));
//
//	//var hue = new PIXI.ColorMatrixFilter();
//	//hue.matrix = [-0.33607998490333557, 0.49079906940460205, 0.8452808856964111, 0, 0.845812201499939, -0.3362049460411072, 0.4903927445411682, 0, 0.4909151792526245, 0.8456892967224121, -0.336604505777359, 0, 0, 0, 0, 1];
//	//return hue;
//}

export function hide_win_text()
{
    madnes_set_visible("win_text_bg", false);
    madnes_set_visible("win_text_2", false);
    madnes_set_visible("win_text", false);
}

function helpers_is_float(n)
{
    return parseFloat(n) !== parseInt(n, 10);
}

export function write_win_text(text)
{
    madnes_set_visible("win_text_bg", true);
    madnes_set_visible("win_text_2", true);
    madnes_set_visible("win_text", true);

    var isFloat = helpers_is_float(text);

    ctrl_set_win_text_bg(text, isFloat);

    if(isFloat) {
        text = parseFloat(text).toFixed(2);
    }
    else
    {
        text = "" + text;
    }

    var t = translate_float_chars(text);

    madnes_set_text("win_text_2", t, true);
    madnes_set_text("win_text", t, true);
}

export function write_bigwin_text(val) {
    madnes_set_text("bigwin_text", val);
    madnes_set_text("bigwin_text_2", val);
}

/**
 * @param {boolean=} show
 */
export function show_bigwin_text(show) {
    if(show === false) {
        madnes_set_visible("bigwin_text", false);
        madnes_set_visible("bigwin_text_2", false);
    } else {
        madnes_set_visible("bigwin_text", true);
        madnes_set_visible("bigwin_text_2", true);
    }
}

function translate_float_chars(text) {

    var num = text;

    var dotIdx = text.indexOf(".");
    if(dotIdx !== -1) {

        var intg = text.slice(0, dotIdx);
        var dec = text.slice(dotIdx + 1, text.length);

        var dec2 = "";
        for(var i = 0; i < dec.length; i++) {
            dec2 += get_char_value(dec[i]);
        }

        num = intg + "k" + dec2;

    }

    return num;
}

function get_char_name(char)
{
    switch(char) {
        case "0": return "upper_zero";
        case "1": return "upper_one";
        case "2": return "upper_two";
        case "3": return "upper_three";
        case "4": return "upper_four";
        case "5": return "upper_five";
        case "6": return "upper_six";
        case "7": return "upper_seven";
        case "8": return "upper_eight";
        case "9": return "upper_nine";
    }
}

function get_char_value(char)
{
    switch(char) {
        case "1": return "b";
        case "2": return "c";
        case "3": return "d";
        case "4": return "e";
        case "5": return "f";
        case "6": return "g";
        case "7": return "h";
        case "8": return "i";
        case "9": return "j";
        case "0":
        default :
            return "a";
    }
}